<script>
import AuthMixins from '@/mixins/AuthMixins';

export default {
	mixins: [AuthMixins],

  data() {
		return {
			newsletters_subscribed: [],
			isLoading: false,
			email: '',
      errors: []
		}
	},

	created() {
    this.$nextTick(() => {
   		if (this.me) {
        this.refreshFromUser();
      } else {
        this.newsletters_subscribed = this.getNewsletters();
      }
    });
  },

	methods: {
		refreshFromUser() {
			// console.log("refreshing newsletters from user:",this.me.newsletters)
			this.newsletters_subscribed = this.me.newsletters;
			this.$forceUpdate();
		},
    validate() {
      this.errors = [];

      if (!this.me && !this.email) {
        this.errors.push('Email required.');
      } else if (!this.me && !this.validEmail(this.email)) {
        this.errors.push('Valid email required.');
      }

      if (!this.errors.length || this.me) {
        return true;
      }

      return false;
    },
    validEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
		doSubscribe() {
      if(this.validate()) {

        this.isLoading = true;

        let payload = {
          'newsletter': this.newsletter,
        }
        if (this.me) {
          payload.user_id = this.me.id;
        } else {
          payload.email = this.email;
        }

        return this.$api.newsletterSubscribe(payload).then(
          (response) => {
            if (response.data.status == 'success') {
              this.updateUser(response.data.enc_user);
              this.isLoading = false;

							this.$nextTick(() => { // Give vuex a chance to update.
								if (this.me) {
									this.refreshFromUser();
								} else {
									if (this.can_subscribe) {
										this.newsletters_subscribed.push(this.newsletter);
										this.setNewsletters();
                    this.errors = [];
									}
								}
							})
              this.emitter.emit('toast', {message:'Newsletter subscribe successfully', type:'success'});
            }
          }
        ).catch((response) => {
          console.log("Could not subscribe to newsletter.", response);
          this.emitter.emit('toast', {message: this.errors[0], type:'error'});
          this.email = '';
          this.errors = [];
          this.isLoading = false;
        });
      }
		},
		getNewsletters() {
			let name = "escape_newsletters=";
			let decodedCookie = decodeURIComponent(document.cookie);
			let ca = decodedCookie.split(';');
			for(let i = 0; i <ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length).split("|");
				}
			}
			return [];
		},
		setNewsletters() {
			let value = this.newsletters_subscribed.join("|");
			let expiresDays = 365;
			let d = new Date();
			d.setTime(d.getTime() + (expiresDays*24*60*60*1000));
			let expires = "expires=" + d.toGMTString();
			document.cookie = "escape_newsletters="+value+";"+expires+";path=/;domain=escapethecity.org";
		}
	},

	computed: {
		can_subscribe() {
			return !this.newsletters_subscribed.includes(this.newsletter);
		}
	},

  watch: {
    email() {
      this.errors = this.errors.length > 0 ? [] : this.validate();      
    }
  }
}
</script>
